import {SelectValidator, TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import localization from "../../../config/localization";
import React from "react";
import {DateTimePicker, MuiPickersUtilsProvider} from "material-ui-pickers";
import DateFnsUtils from "@date-io/date-fns";
import {Event} from "@material-ui/icons";
import moment from "moment";
import {Button, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup} from "@material-ui/core";
import FilePondUploader from "../../../components/Letflow/FilePondUploader";
import {ErrorMessage} from "formik";
import styled from "styled-components";
import {ImagePicker, VideoPicker} from "../../../components/Letflow/Form";
import AsyncSelect from "react-select/lib/Async";
import {request} from "../../../api-client";


const formNewUrl = (path) => {
  return process.env.REACT_APP_CDN_HOST.concat('/' + path)
}

const FormView = (formikProps) => {
  const {values, handleChange, setFieldValue, handleSubmit, resetForm} = formikProps
  return (
    <div style={{padding: '0 25px'}}>
      <ValidatorForm onSubmit={() => handleSubmit()}>

      <TextValidator
        style={{ width: "100%", marginBottom: "20px" }}
        id="name"
        label={localization.get('form.name')}
        name="name"
        value={values.name}
        onChange={handleChange}
        validators={['required']}
        errorMessages={[localization.get('validator.is_required')]}
      />
      <TextValidator
        style={{ width: "100%", marginBottom: "20px" }}
        id="description"
        label={localization.get('form.description')}
        name="description"
        value={values.description}
        onChange={handleChange}
      />
      <br/>

      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DateDiv>
        <DateTimePicker
          autoOk
          autoSubmit
          disablePast
          format={"dd/MM/yyyy hh:mm a"}
          dateRangeIcon={<Event/>}
          label={localization.get('livestream.start_time')}
          value={values.startTime}
          onChange={(value) => setFieldValue('startTime', value)}
        />
        <ErrorMessage name="startTime" className="web-like-error">
          {msg => <div className="web-like-error font12">{msg}</div>}
        </ErrorMessage>
        </DateDiv>
      </MuiPickersUtilsProvider>

      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DateDiv style={{marginLeft: 45}}>
        <DateTimePicker
          autoOk
          disablePast
          format={"dd/MM/yyyy hh:mm a"}
          dateRangeIcon={<Event/>}
          label={localization.get('livestream.end_time')}
          value={values.endTime}
          onChange={(value) => setFieldValue('endTime', value)}
          minDate={values.startTime}
          maxDate={moment(values.startTime).add(12, 'hours')}
          disabled={!values.startTime}
        />
        <ErrorMessage name="endTime" className="web-like-error">
          {msg => <div className="web-like-error font12">{msg}</div>}
        </ErrorMessage>
        </DateDiv>
      </MuiPickersUtilsProvider>

      <FormControl style={{marginTop: 10}}>
        <RadioGroup
          name="radio"
          value={values.radio}
          onChange={e => {
            setFieldValue('radio', e.target.value)
            setFieldValue('videoId', null)
            setFieldValue('startImageId', null)
            setFieldValue('endImageId', null)
            setFieldValue('streamId', '')
            setFieldValue('source', '')
            setFieldValue('fake', e.target.value === 'fake' ? 1 : 0)
          }}
          style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
        >
          <FormControlLabel value="live" control={<Radio color="default"/>} label={localization.get('livestream')}/>
          <FormControlLabel value="fake" control={<Radio color="default"/>} label={localization.get('livestream.fake')}/>
        </RadioGroup>
      </FormControl>

      <FormControl style={{display: 'block'}}>
        <SelectValidator
          label={localization.get("form.source")}
          id="source"
          name="source"
          value={values.source}
          onChange={e => {
            setFieldValue('source', e.target.value)
          }}
          style={{width: 175}}
          validators={['required']}
          errorMessages={[localization.get('validator.is_required')]}
        >
          {values.radio === 'live' && <MenuItem value="youtube">{localization.get('form.youtube')}</MenuItem>}
          {values.radio === 'live' && <MenuItem value="vimeoLive">{localization.get('form.vimeo')}</MenuItem>}
          {values.radio === 'fake' && <MenuItem value="vimeo">{localization.get('form.vimeo')}</MenuItem>}
          {values.radio === 'fake' && values.allowFakeLivestreams && <MenuItem value="bloomclouds">{localization.get('Bloomclouds')}</MenuItem>}
        </SelectValidator>
      </FormControl>

      {values.source &&
        <>
          {values.source !== 'bloomclouds' ?
            <>
              <TextValidator
                style={{width: "100%", margin: "20px 0"}}
                id="streamId"
                label={localization.get(values.source === 'youtube' ? 'form.stream_youtube_id' : 'form.stream_vimeo_url')}
                name="streamId"
                value={values.streamId}
                onChange={handleChange}
                validators={['required']}
                errorMessages={[localization.get('validator.is_required')]}
              />
              <ErrorMessage name="streamId" className="web-like-error">
                {msg => <div className="web-like-error font12">{msg}</div>}
              </ErrorMessage>
            </>
            :
            <>
              <br/>
              <div style={{fontSize: 16}}>{localization.get('video')}</div>
              <ErrorMessage name="videoId" className="web-like-error">
                {msg => <div className="web-like-error font12">{msg}</div>}
              </ErrorMessage>
              {values.video && values.showPreview && <VideoPicker video={values.video.src} previewOnly={true}/>}
              <FilePondUploader
                disableForm={values.disabled}
                updateDisableForm={value => setFieldValue('disabled', value)}
                id={"video"}
                type={"video"}
                allowedTypes={["video/mp4"]}
                onIdChange={video => {
                  setFieldValue('videoId', video ? video.id : null)
                  setFieldValue('videoPreview', video ? formNewUrl(video.path) : null)
                }}
                setPreview={() => values.onSetPreview(values, setFieldValue, 'video')}
              />
            </>
          }

          <div style={{fontSize: 16}}>{localization.get('livestream.start_image')}</div>
          <ErrorMessage name="startImageId" className="web-like-error">
            {msg => <div className="web-like-error font12">{msg}</div>}
          </ErrorMessage>
          {values.startImage && values.showPreview && <ImagePicker image={values.startImage.src} previewOnly={true}/>}
          <FilePondUploader
            disableForm={values.disabled}
            updateDisableForm={value => setFieldValue('disabled', value)}
            id={"startImage"}
            type={"image"}
            allowedTypes={["image/*"]}
            onIdChange={image => {
              setFieldValue('startImageId', image ? image.id : null)
              setFieldValue('startImagePreview', image ? formNewUrl(image.path) : null)
            }}
            setPreview={() => values.onSetPreview(values, setFieldValue, 'startImage')}
          />

          <div style={{fontSize: 16}}>{localization.get('livestream.end_image')}</div>
          <ErrorMessage name="endImageId" className="web-like-error">
            {msg => <div className="web-like-error font12">{msg}</div>}
          </ErrorMessage>
          {values.endImage && values.showPreview && <ImagePicker image={values.endImage.src} previewOnly={true}/>}
          <FilePondUploader
            disableForm={values.disabled}
            updateDisableForm={value => setFieldValue('disabled', value)}
            id={"endImage"}
            type={"image"}
            allowedTypes={["image/*"]}
            onIdChange={image => {
              setFieldValue('endImageId', image ? image.id : null)
              setFieldValue('endImagePreview', image ? formNewUrl(image.path) : null)
            }}
            setPreview={() => values.onSetPreview(values, setFieldValue, 'endImage')}
          />
        </>
      }

        <FormControl fullWidth style={{marginTop: 10}}>
          <span>{localization.get('livestream.content_creator')}</span>
          <AsyncSelect
            styles={{
              menu: base => ({
                ...base,
                zIndex: 10
              })
            }}
            theme={theme => ({
              ...theme,
              borderRadius: 0
            })}
            placeholder={localization.get('conversation.filter_users')}
            loadingMessage={() => localization.get('loading')}
            noOptionsMessage={() => localization.get('no_options')}
            defaultOptions
            value={values.selectedContentCreator}
            onChange={(selectedContentCreator) => {
              setFieldValue('selectedContentCreator', selectedContentCreator)
            }}
            loadOptions={inputValue =>
              request.contentCreator
                .getAll({ filterBy: [{ column: "name", filter: inputValue }] })
                .then(res => res.map(contentCreator => ({ value: contentCreator.id, label: `${contentCreator.name} - (${contentCreator.type.name})` })))
            }
          />
        </FormControl>

      <div style={{margin: '20px 0 5px', float: 'right'}}>
        <Button onClick={() => values.handleCloseForm(resetForm)} color='default'>{localization.get("cancel")}</Button>
        <Button type="submit" color='info' disabled={values.disabled}>{localization.get("form.schedule")}</Button>
      </div>
      </ValidatorForm>
    </div>
  )
}

export default FormView

const DateDiv = styled.div`
  display: inline-flex;
  flex-direction: column;
`
